<template>
  <div class="tree-node">
    <node-content class="tree-node-content"></node-content>
    <div class="tree-node-children">
      <tree-node
        v-for="(child, idx) of nodeData.children"
        :nodeData="child"
        :id="child.id"
        :key="idx">
      </tree-node>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tree-node',
  components: {
    'node-content': {
      render (h) {
        const tree = this.$parent.tree
        const nodeData = this.$parent.nodeData
        const parentData = this.$parent.$parent.nodeData || null
        return tree.$scopedSlots.default({ data: nodeData, parentData })
      }
    }
  },
  props: {
    nodeData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tree: null
    }
  },
  created () {
    if (this.$parent.isTreeRoot) {
      this.tree = this.$parent
    } else {
      this.tree = this.$parent.tree
    }
  }
  // computed: {
  //   showChildren () {
  //     if (!this.isExpand) return false
  //     if (!this.nodeData.children && this.nodeData.children.length) return false
  //     return this.isExpand(this.nodeData)
  //   }
  // }
}
</script>

<style lang="stylus" scoped>
.tree-node-children
  margin-left 15px
</style>
